import { MLBHeader } from '@gameday/header/index';
import { GamePickerContainer } from '@gameday/gamePicker';
import MLBGamedayTrackingEngine from '@gameday/tracking/MLBGamedayTrackingEngine';
import PageTitle from '@gameday/components/Seo/PageTitle';
import MLBGamedayAdsEngine from '@gameday/ads/MLBGamedayAdsEngine';

export default {
    header: MLBHeader,
    scoreboard: GamePickerContainer,
    tracking: MLBGamedayTrackingEngine,
    pagetitle: PageTitle,
    ads: MLBGamedayAdsEngine
};
